export default __webpack_public_path__ + "static/media/complex-logo.bcd4b285.png";